export default {
  forecastList: [],
  financialsList: [],
  availableSaving: false,
  alreadySaved: false,
  isSaving: false,
  isUpdating: false,
  loadedModel: undefined,
  modelType: undefined,
  hasUpdates: false,
  isPreviewMode: false,
}
